import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import QRCode from 'react-native-qrcode-svg';
import { useThemeColors } from '@/hooks/residents/useThemeColors';
import { REDESIGN_TYPOGRAPHY } from '@/constants/residents/homeConstants';
import { CloseButton } from '@/components/common/residents/CloseButton';

interface WifiQRCodeModalProps {
  visible: boolean;
  title: string;
  value: string;
  onClose: () => void;
}

export const WifiQRCodeModal: React.FC<WifiQRCodeModalProps> = ({
  visible,
  title,
  value,
  onClose,
}) => {
  const { colors } = useThemeColors();

  if (!visible) return null;

  return (
    <TouchableOpacity style={styles.overlay} activeOpacity={1} onPress={onClose}>
      <TouchableOpacity
        style={[styles.content, { backgroundColor: colors.bg.modal, borderColor: colors.card.border }]}
        activeOpacity={1}
        onPress={() => {}}
      >
        <CloseButton onPress={onClose} />
        <Text style={[styles.title, { color: colors.text.primary }]}>{title}</Text>
        <View style={styles.qrContainer}>
          <QRCode value={value} size={200} color="black" backgroundColor="white" />
        </View>
        <Text style={[styles.caption, { color: colors.text.muted }]}>
          Scan with your phone's camera
        </Text>
      </TouchableOpacity>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  content: {
    borderRadius: 24,
    borderWidth: 1,
    padding: 24,
    alignItems: 'center',
    width: '85%',
    maxWidth: 360,
    position: 'relative',
  },
  title: {
    ...REDESIGN_TYPOGRAPHY.sectionTitle,
    textAlign: 'center',
    marginTop: 16,
    marginBottom: 24,
  },
  qrContainer: {
    backgroundColor: 'white',
    borderRadius: 12,
    padding: 16,
    alignItems: 'center',
    justifyContent: 'center',
  },
  caption: {
    ...REDESIGN_TYPOGRAPHY.caption,
    textAlign: 'center',
    marginTop: 16,
  },
});
